import React from 'react';
import isEmpty from 'lodash/isEmpty';
import IconLock from './IconLock';
import IconHide from './IconHide';
// import IconSwap from './IconSwap';
import { Droppable } from 'react-beautiful-dnd';
import { getListStyle } from '../../../components/Mapbox/Utils';
import DriverListSteps from './Steps';
import sortBy from 'lodash/sortBy';
import IconSwap from './IconSwap copy';
import { Tooltip } from 'antd';

const DriverList = ({
  hours,
  oneHourPx,
  isDragging,
  riderIdsHide,
  routePlan,
  minutes,
  startTime,
  solutions,
  stepCompleted,
  stepsHovered,
  onHoverStep,
  handleCloseStepPopup,
  onClickStep,
  setStepsHovered,
  onClickRoute,
  setShowMoreRoute,
  onClickHide,
  onClickLock,
  riderIdsLock,
  onClickSwap,
}) => {
  if (!routePlan?.riders || isEmpty(solutions)) return;

  const routes = sortBy(routePlan?.riders, 'riderId');

  return (
    <>
      {routes.map((route, index) => {
        const solution = solutions ? solutions[route.riderId] : {};
        const steps = solution?.steps || [];
        const workingPercent = route.workingPercent || 0;
        let loadPercent = 0;
        const percentLevel = 'high';
        const color = solution.color;
        const isLock = riderIdsLock.includes(route.riderId);
        const isHide = riderIdsHide.includes(route.riderId);

        return (
          <div
            key={index}
            className="tr"
            style={{
              minWidth: (hours.length + 1) * oneHourPx,
              width: '100%',
            }}
          >
            <div className={`td ${isDragging && 'isDragging'}`}>
              <div className="driver-name">
                <IconLock isLock={isLock} onClickLock={() => onClickLock(route.riderId)} />
                <IconHide isHide={isHide} onClickHide={() => onClickHide(route.riderId)} />

                <div className="driver-info">
                  <Tooltip title={route?.user?.name}>
                    <div
                      className="name"
                      // onClick={() => onClickRoute(route, null)}
                    >
                      {route?.user?.name || ''}
                    </div>
                  </Tooltip>
                  <div className={`working-time ${percentLevel}`}>
                    <div className="capacity" style={{ background: '#' + color }}>
                      <div className="text">
                        {route.timeStart || 'N/A'} - {route.timeEnd || 'N/A'}
                      </div>
                      <div className="completed" style={{ width: loadPercent + '%' }}></div>
                    </div>
                    <div className="percent">{workingPercent + '%'}</div>
                  </div>
                </div>
                {/* <Button
                  className="btn-summary"
                  style={{
                    background: 'transparent',
                    border: 'none',
                    padding: 0,
                    marginLeft: '10px',
                  }}
                  onClick={() => {
                    onClickRoute(route, 'start');
                    setShowMoreRoute(true);
                  }}
                >
                  <ReactSVG
                    className="icon"
                    style={{
                      height: '16px',
                    }}
                    src="/icons/summary.svg"
                  />
                </Button> */}
                <IconSwap className="swap" onClickSwap={() => onClickSwap(route)} />
              </div>
              {/* <DriverAssign
                driver={route}
                isDragging={isDragging}
                route={route}
                assignStops={solutions[`assign_${route.riderId}`]?.steps || []}
              /> */}
            </div>
            <Droppable key={`${route.riderId}`} droppableId={`${route.riderId}`} direction="horizontal">
              {(provided, snapshot) => (
                <div
                  className={`td ${isDragging && 'isDragging'}`}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                  ref={provided.innerRef}
                  style={{
                    ...getListStyle(isDragging, snapshot.isDraggingOver),
                  }}
                >
                  <DriverListSteps
                    route={route}
                    steps={steps}
                    minutes={minutes}
                    startTime={startTime}
                    color={color}
                    solutions={solutions}
                    stepCompleted={stepCompleted}
                    oneHourPx={oneHourPx}
                    stepsHovered={stepsHovered}
                    onHoverStep={onHoverStep}
                    handleCloseStepPopup={handleCloseStepPopup}
                    onClickStep={onClickStep}
                    setStepsHovered={setStepsHovered}
                    onClickRoute={onClickRoute}
                    setShowMoreRoute={setShowMoreRoute}
                    routePlan={routePlan}
                  />
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </div>
        );
      })}
    </>
  );
};

export default DriverList;
